module.exports = __webpack_public_path__ + "img/health20_7-9-2021.fc3881b0.jpg";